module.exports = __webpack_public_path__ + "img/sq6m_05.7913a7d0.jpg";